// Angular
import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
// RxJS
import { Observable, BehaviorSubject, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
// NGRX
// Service
import { SubheaderService } from 'app/core/_base/layout';
import { LayoutUtilsService, MessageType } from 'app/core/_base/crud';
//Models

import { HanhChanhService } from '../hanh-chanh-service/hanh-chanh.service';
import { DatPhongHopModel } from '../dat-phong-hop-model/dat-phong-hop.model';


@Component({
	selector: 'kt-phong-hop-edit',
	templateUrl: './dat-phong-hop-edit.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})

export class DatPhongHopEditComponent implements OnInit, OnDestroy {
	// Public properties
	DatPhongHop: DatPhongHopModel;
	DatPhongHopForm: FormGroup;
	hasFormErrors: boolean = false;
	loadingSubject = new BehaviorSubject<boolean>(true);
	loading$: Observable<boolean>;
	viewLoading: boolean = false;
	isChange: boolean = false;
	selectedStatus: string = "0";
	fixedPoint = 0;

	isZoomSize: boolean = false;
	//Role
	DUYET = 153;
	LIST_ROLES_USER: [] = [];
	SHOW_BUTTON_APPROVE = new BehaviorSubject<boolean>(false);
	private componentSubscriptions: Subscription;
	constructor(
		public dialogRef: MatDialogRef<DatPhongHopEditComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private DatPhongHopFB: FormBuilder,
		public dialog: MatDialog,
		private layoutUtilsService: LayoutUtilsService,
		private changeDetectorRefs: ChangeDetectorRef,
		private DatPhongHopsService: HanhChanhService) {
			let user = JSON.parse(localStorage.getItem("UserInfo"));
			this.LIST_ROLES_USER = user.roles;
	}

	/**
	 * On init
	 */
	ngOnInit() {
		this.SHOW_BUTTON_APPROVE.next(this.isTrueButton(this.DUYET));
		this.viewLoading = false;
		this.DatPhongHop = new DatPhongHopModel();
		if (this.data.DatPhongHop && Number(this.data.DatPhongHop.Id_DP) > 0) {
			this.DatPhongHopsService.getDatPhongHopById(this.data.DatPhongHop.Id_DP).subscribe(res => {
				if (res.status == 1 && res.data) {
					this.DatPhongHop = res.data;
					this.createForm();
					this.changeDetectorRefs.detectChanges();
				}
			});
		}
		else {
			this.DatPhongHop = this.data.DatPhongHop;
		}
		this.createForm();
	}

	/**
	 * On destroy
	 */
	ngOnDestroy() {
		if (this.componentSubscriptions) {
			this.componentSubscriptions.unsubscribe();
		}
	}

	/**
	 * Create form
	 */
	createForm() {
		this.DatPhongHopForm = this.DatPhongHopFB.group({
			NoiDungHop: [(this.DatPhongHop.NoiDungHop == null || this.DatPhongHop.NoiDungHop == '') ? '' : this.DatPhongHop.NoiDungHop, Validators.required],
			LyDoKhongXacNhan: [(this.DatPhongHop.LyDoKhongXacNhan == null || this.DatPhongHop.LyDoKhongXacNhan == '') ? '' : this.DatPhongHop.LyDoKhongXacNhan],
			LyDoHuy: [(this.DatPhongHop.LyDoHuy == null || this.DatPhongHop.LyDoHuy == '') ? '' : this.DatPhongHop.LyDoHuy],
		});
		this.selectedStatus = this.DatPhongHop.TinhTrang + "";
	}
	/**
	 * Returns page title
	 */
	getTitle(): string {
		if (this.DatPhongHop.Id_DP == 0) {
			return 'Thêm mới đăng ký mới';
		}
		return `Chỉnh sửa đăng ký - ${this.DatPhongHop.NgayDatPhong} ${this.DatPhongHop.TuGio}  - ${this.DatPhongHop.DenGio}`;
	}

	/**
	 * Check control is invalid
	 * @param controlName: string
	 */
	isControlInvalid(controlName: string): boolean {
		const control = this.DatPhongHopForm.controls[controlName];
		const result = control.invalid && control.touched;
		return result;
	}

	/**
	 * Save data
	 *
	 * @param withBack: boolean
	 */
	onSubmit(type: boolean) {
		this.hasFormErrors = false;
		const controls = this.DatPhongHopForm.controls;
		/** check form */
		if (this.DatPhongHopForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);

			this.hasFormErrors = true;
			return;
		}
		let _date = new Date();
		if (this.data.DatPhongHop.NgayDatPhong) {
			try {
				_date = new Date(this.data.DatPhongHop.NgayDatPhong);
			} catch (ex) {
				const message = 'Ngày đặt phòng không hợp lệ';
				this.layoutUtilsService.showActionNotification(message, MessageType.Create, 3000, true, false);
				return;
			}
		}
		let editedDatPhongHop = this.prepareDatPhongHops();
		if (this.DatPhongHop.Id_DP > 0) {
			this.updateDatPhongHop(editedDatPhongHop)
			return;
		}

		this.addDatPhongHop(editedDatPhongHop, type);
	}

	/**
	 * Returns object for saving
	 */
	prepareDatPhongHops(): DatPhongHopModel {
		const controls = this.DatPhongHopForm.controls;
		const _DatPhongHop = new DatPhongHopModel();
		_DatPhongHop.clear();
		_DatPhongHop.NoiDungHop = controls['NoiDungHop'].value;
		_DatPhongHop.TinhTrang = Number(this.selectedStatus);

		if (_DatPhongHop.TinhTrang == 2) {
			_DatPhongHop.LyDoKhongXacNhan = controls['LyDoKhongXacNhan'].value;
		}
		else if (_DatPhongHop.TinhTrang == 3) {
			let _date = new Date(this.data.DatPhongHop.NgayDatPhong);
			if (!this.checkDateCancelBooking(_date)) {
				const message = 'Không thể hủy đặt phòng';
				this.layoutUtilsService.showActionNotification(message, MessageType.Create, 3000, true, false);
				return;
			}
			_DatPhongHop.LyDoHuy = controls['LyDoHuy'].value;

		}
		_DatPhongHop.NgayDatPhong = this.data.DatPhongHop.NgayDatPhong;
		_DatPhongHop.TuGio = this.data.DatPhongHop.TuGio;
		_DatPhongHop.DenGio = this.data.DatPhongHop.DenGio;
		_DatPhongHop.Id_Phong = this.data.DatPhongHop.Id_Phong;
		//gán lại giá trị id
		if (this.DatPhongHop.Id_DP > 0) {
			_DatPhongHop.Id_DP = this.DatPhongHop.Id_DP;
		}
		return _DatPhongHop;
	}
	/**
	 * Add item
	 *
	 * @param _DatPhongHop: DatPhongHopModel
	 * @param withBack: boolean
	 */
	addDatPhongHop(_DatPhongHop: DatPhongHopModel, withBack: boolean = false) {

		this.DatPhongHopsService.createDatPhongHop(_DatPhongHop).subscribe(res => {
			if (res.status == 1) {
				//this.isChange = true;
				//console.log("res", res.data);
				const message = `Đăng ký phòng thành công.`;
				this.layoutUtilsService.showActionNotification(message, MessageType.Create, 2000, true, false);
				this.DatPhongHopForm.reset();
				if (withBack)
					this.dialogRef.close( res.data);
					// this.dialogRef.close(null);
			}
			else {
				this.layoutUtilsService.showActionNotification(res.error.message, MessageType.Create, 2000, true, false);
			}
		});
	}

	/**
	 * Update item
	 *
	 * @param _DatPhongHop: DatPhongHopsModel
	 * @param withBack: boolean
	 */
	updateDatPhongHop(_DatPhongHop: DatPhongHopModel, withBack: boolean = false) {

		this.DatPhongHopsService.updateDatPhongHop(_DatPhongHop).subscribe(res => {
			if (res.status == 1) {
				this.isChange = true;
				const message = `Đăng ký phòng đã được cập nhập`;
				this.layoutUtilsService.showActionNotification(message, MessageType.Update, 2000, true, false);
				this.dialogRef.close(this.isChange);
			}
			else {
				this.layoutUtilsService.showActionNotification(res.error.message, MessageType.Update, 20000, true, false);
			}
		});
	}

	/**
	 * Close alert
	 *
	 * @param $event
	 */
	onAlertClose($event) {
		this.hasFormErrors = false;
	}

	numberOnly(event): boolean {
		const charCode = (event.which) ? event.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
		return true;
	}

	closeDialog() {
		this.dialogRef.close(this.isChange);
	}
	ValidateChangeNumberEvent(event: any) {
		
		if (event.target.value == null || event.target.value == '') {
			const message = 'Không thể để trống dữ liệu';
			this.layoutUtilsService.showActionNotification(message, MessageType.Create, 3000, true, false);
			return false;
		}
		var count = 0;
		for (let i = 0; i < event.target.value.length; i++) {
			if (event.target.value[i] == '.') {
				count += 1;
			}
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showActionNotification(message, MessageType.Create, 3000, true, false);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showActionNotification(message, MessageType.Create, 3000, true, false);
			return false;;
		}
		return true;
	}

	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}

	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}

	f_currency_V2(value: string): any {
		if (value == '-1') return '';
		if (value == null || value == undefined || value == '') value = '0';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}

	changeValueOfForm(controlName: string, event: any) {
		if (this.ValidateChangeNumberEvent(event)) {
			let tmpValue = this.DatPhongHopForm.controls[controlName].value.replace(/,/g, "");
			this.DatPhongHopForm.controls[controlName].setValue(

				this.f_currency_V2(tmpValue)

			);
		}
		else {
			this.DatPhongHopForm.controls[controlName].setValue(event.target.value);
		}
	}


	f_convertDateTime(date: string) {
		var componentsDateTime = date.split("/");
		var date = componentsDateTime[0];
		var month = componentsDateTime[1];
		var year = componentsDateTime[2];
		var formatConvert = year + "-" + month + "-" + date + "T00:00:00.0000000";
		return new Date(formatConvert);
	}
	f_convertDate(p_Val: any) {
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return a.getFullYear() + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + ("0" + (a.getDate())).slice(-2);
	}

	resizeDialog() {
		if (!this.isZoomSize) {
			this.dialogRef.updateSize('100vw', '100vh');
			this.isZoomSize = true;
		}
		else if (this.isZoomSize) {
			this.dialogRef.updateSize('900px', 'auto');
			this.isZoomSize = false;
		}

	}
	isTrueButton(ROLENUMBER: number) {
		if (this.LIST_ROLES_USER.findIndex(x => x == ROLENUMBER) > -1) {
			return true;
		}
		return false;
	}
	checkDateCancelBooking(date) {
		let now = new Date();
		if (date > now) {
			return true;
		}
		return false;
	}
}
